import { ChartHeaderComponent } from './chart-header.component'

export const CHARTHEADERCOMPONENT_DECLARATION: any[] = [ChartHeaderComponent]
